import React from 'react';

import { observer } from 'mobx-react';

import AddCommentActivities from 'ui/AddCommentActivities';

import EntitiesActivities from 'stores/EntitiesActivities';

interface Props {
  activities: EntitiesActivities | undefined;
  placeholder?: string;
}

const EntitiesDetailsActivitiesFooter: React.FunctionComponent<Props> = ({
  activities,
  placeholder = 'Post an update',
}): React.ReactElement => {
  if (!activities) {
    return <></>;
  }

  return (
    <AddCommentActivities
      placeholder={placeholder}
      uploadFile={activities.uploadFile}
      sendMessage={activities.addMessage}
    />
  );
};

export default observer(EntitiesDetailsActivitiesFooter);
